import { DEFAULT_NETWORK, NETWORKS } from '@/constants';
import { useLocation, Navigate } from 'react-router';
import { Layout } from '@/components';
import { useNetwork } from '@/hooks';

export default function ValidateNetwork() {
  const location = useLocation();
  const { network } = useNetwork();

  /* 
    If network is invalid, the assumption is network is missing so we add default network to path.
    Otherwise, if network or path is invalid it will throw a 404.
  */
  if (network && !NETWORKS.includes(network)) {
    const newPath = `/${DEFAULT_NETWORK}${location.pathname}`;

    return <Navigate to={newPath} replace />;
  }

  return <Layout />;
}
